var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"k-toast k-body-md"},[_c('span',[_vm._v(_vm._s(_vm.content))]),(_vm.showClose)?_c('div',{staticClass:"close-icon",on:{"click":function($event){_vm.visible=false}}},[_c('KkIcon',{attrs:{"name":"ic_cross_line_semibold_lg","size":"sm"}})],1):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }